import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye } from "react-icons/fa";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import { SortController } from "ag-grid-community";
import Swal from "sweetalert2";

function TaxInvoiceAddNew() {
  const [visible, setvisible] = useState(true);
  const [loading, setLoading] = useState(true); // State for loading indicator
  // Serch Fuctionallity ....
  const [selectedOption, setSelectedOption] = useState("column");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null); // Track selected row

  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [taxInvoiceList, setTaxInvoiceList] = useState([]);
  let navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 29 && item.add
  );

  useEffect(() => {
    getsearchCompanySpecificCriteria();
    getsetsearchcompanyspecificdaterange();
  }, []);

  useEffect(() => {
    if (searchCompanySpecificDateRangeId != 7) {
      getTaxInvoiceList();
    }
  }, [
    searchCompanySpecificCriteriaId,
    searchCompanySpecificDateRangeId,
    searchParameter,
  ]);

  useEffect(() => {
    if (
      formDate != "" &&
      toDate != "" &&
      searchParameter2 != "" &&
      searchCompanySpecificDateRangeId == 7
    ) {
      obj.search_parameter = searchParameter2;
      getTaxInvoiceList();
    }
  }, [searchParameter2]);

  //for tax invoice list
  let obj = {
    search_company_specific_criteria_id: searchCompanySpecificCriteriaId,
    search_company_specific_date_range_id: searchCompanySpecificDateRangeId,
    search_parameter: searchParameter,
  };

  const getTaxInvoiceList = () => {
    axios
      .post("/api/purple-fusion/taxinvoice/getsalesorderfortaxinvoice", obj, {
        ...headers,
      })
      .then((response) => {
        setTaxInvoiceList(response.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for column...

  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 6 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  //for date
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const createTaxInvoice = (customerId, salesOrderId, customername) => {
    Swal.fire({
      title: "Processing...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios
      .post(
        "/api/purple-fusion/taxinvoice/create",
        { customer_id: customerId, sales_order_id: salesOrderId },
        headers
      )
      .then((response) => {
        Swal.close();
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,

              onClose: () => {
                if (
                  erplist.some(
                    (item) => item.erp_module_id === 30 && item.add && item.view
                  )
                ) {
                  setvisible(false);
                  sessionStorage.setItem("name", customername);
                  navigate(
                    `/taxinvoiceitem/add/${response.data.id}?someKey=true`,
                    {
                      state: { sales_order_id: salesOrderId },
                    }
                  );
                } else {
                  toast.warning("don't have access to Tax Invoice Item", {
                    autoClose: 2000,
                    onClose: () => {
                      navigate(`/taxinvoice/list`);
                      setvisible(false);
                    },
                  });
                }
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        Swal.close();
        // setvisible(false);
        // navigate("/taxinvoice/list");
      });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };

  const customStyles = {
    content: {
      width: "95%",
      height: "80%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      // zIndex: 999,
    },
  };

  const onRowClicked = (event) => {
    setSelectedRow(event.data); // Set selected row data
  };

  //   const defaultColDefs = [
  //     { headerName: "SNO.", field: "sr", width: 85 },
  //     { headerName: "Customer Name", field: "customername", width: 250 },
  //     { headerName: "Customer PO Code", field: "purchesOrderNumber", width: 250 },
  //     { headerName: "Sales Order Code", field: "code", width: 200 },
  //     {
  //       headerName: "Action",
  //       field: "id",
  //       width: 120,
  //       filter: false,
  //       sortable: false,

  //       cellRenderer: (params) => (
  //         <div className="mt-2">
  //           <button>
  //             <FaEye
  //               title="Sales Order Preview"
  //               className="w-4 h-4 mr-3 text-blue-700"
  //               onClick={() => {
  //                 sessionStorage.setItem("tab", "Items");
  //                 window.open(
  //                   `/salesorderall/${params.data.id}/${params.data.customer_id}`,
  //                   "_blank"
  //                 );
  //               }}
  //             />
  //           </button>
  //           <button
  //             onClick={() => {
  //               createTaxInvoice(
  //                 params.data.customer_id,
  //                 params.data.id,
  //                 params.data.customername
  //               );
  //             }}
  //             className="text-blue-700 w-14 border bg-transparent hover:bg-blue-700 hover:text-white-A700 border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1 text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
  //           >
  //             Save
  //           </button>
  //         </div>
  //       ),
  //     },
  //   ];

  const defaultColDefs = [
    { headerName: "SNO.", field: "sr", width: 65 },
    { headerName: "Customer Name", field: "customername", width: 150 },
    { headerName: "Customer PO Code", field: "purchesOrderNumber", width: 150 },
    { headerName: "Sales Order Code", field: "code", width: 180 },
    {
      headerName: "Action",
      field: "id",
      width: 120,
      filter: false,
      sortable: false,
      cellRenderer: (params) => (
        <div className="mt-2">
          <button
            onClick={() => {
              window.open(
                `/salesorderall/${params.data.id}/${params.data.customer_id}`,
                "_blank"
              );
            }}
          >
            <FaEye
              className="w-4 h-4 mr-3 text-blue-700"
              title="Sales Order Preview"
            />
          </button>
          <button
            onClick={() => {
              createTaxInvoice(
                params.data.customer_id,
                params.data.id,
                params.data.customername
              );
            }}
            className="text-blue-700 w-14 border bg-transparent hover:bg-blue-700 hover:text-white-A700 border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1 text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
          >
            Save
          </button>
        </div>
      ),
    },
  ];

  const gridOptions = {
    overlayNoRowsTemplate: `
            <div id="progress-bar-id" class="flex items-center justify-center">
                <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
            </div>
        `,
  };
  const ColDefaultVale = { filter: true };

  return (
    <>
      {showActionColumn ? (
        <div>
          <div>
            <Modal isOpen={visible} style={customStyles}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[12px] justify-start md:px-5 w-full">
                    <div className=" flex flex-row w-[100%]">
                      <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                        <Text
                          className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] mr-8"
                          size="txtInterMedium24"
                        >
                          Add Tax Invoic
                        </Text>
                        <input
                          type="radio"
                          id="column"
                          name="option"
                          checked={selectedOption === "column"}
                          onChange={(event) => {
                            handleOptionChange(event);
                            setsearchCompanySpecificDateRangeId("");
                            setsearchParameter("");
                          }}
                          className="mr-1 scale-100"
                        />
                        <label className=" text-gray-600 mr-2 text-sm">
                          {" "}
                          Column
                        </label>

                        <input
                          type="radio"
                          className="scale-100 mr-1 "
                          id="date"
                          name="option"
                          checked={selectedOption === "date"}
                          onChange={(event) => {
                            handleOptionChange(event);
                            setsearchCompanySpecificCriteriaId("");
                            setsearchParameter("");
                          }}
                        />
                        <label className=" text-gray-600 text-sm mr-2">
                          {" "}
                          Date
                        </label>

                        {selectedOption == "column" && (
                          <Select
                            options={searchCompanySpecificCriteria.map(
                              (resstate) => ({
                                label: resstate.criteria,
                                value: resstate.id,
                              })
                            )}
                            className="bg-white-A700 border border-gray-200_02 "
                            onChange={(selectedoption) => {
                              setsearchCompanySpecificCriteriaId(
                                selectedoption.value
                              );
                            }}
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: "30px", // Adjust the height as needed
                                // minHeight: '10px', // Ensure the minimum height is also set
                                width: "200px", // Adjust the width as needed
                                display: "flex",
                                alignItems: "center", // Center vertically
                                justifyContent: "center", // Center horizontally
                              }),
                            }}
                          />
                        )}
                        {selectedOption == "date" && (
                          <Select
                            options={searchcompanyspecificdaterange.map(
                              (resstate) => ({
                                label: resstate.date_range,
                                value: resstate.search_date_range_id,
                              })
                            )}
                            className="bg-white-A700 border border-gray-200_02 "
                            onChange={(selectedoption) => {
                              setsearchCompanySpecificDateRangeId(
                                selectedoption.value
                              );
                            }}
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: "30px", // Adjust the height as needed
                                //  minHeight: '10px', // Ensure the minimum height is also set
                                width: "200px", // Adjust the width as needed
                                display: "flex",
                                alignItems: "center", // Center vertically
                                justifyContent: "center", // Center horizontally
                              }),
                            }}
                          />
                        )}
                        {selectedOption == "column" && (
                          <input
                            name="searchParamater"
                            type="text"
                            // placeholder="Type at least 3 characters"
                            placeholder="Search..."
                            onChange={(e) => {
                              setsearchParameter(e.target.value);
                            }}
                            // onChange={formik.handleChange}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[30%] ml-3 "
                          ></input>
                        )}

                        {selectedOption == "date" &&
                          searchCompanySpecificDateRangeId == 7 && (
                            <div className="flex flex-row">
                              <input
                                name="from_date"
                                type="date"
                                onChange={(e) => {
                                  setFormDate(e.target.value);
                                  setsearchParameter2(
                                    e.target.value.concat("@" + toDate)
                                  );
                                }}
                                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%] ml-3 mr-1  pt-4"
                              />
                              <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2  ">
                                To
                              </Text>

                              <input
                                name="to_date"
                                type="date"
                                onChange={(e) => {
                                  setToDate(e.target.value);
                                  setsearchParameter2(
                                    formDate.concat("@" + e.target.value)
                                  );
                                }}
                                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px]  ml-1 pt-4"
                              />
                            </div>
                          )}
                      </div>
                      <div className="flex flex-row items-center justify-start">
                        {/* <Button
                                                        className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                                                        shape="round"
                                                        color="blue_A700"
                                                        size="base"
                                                        variant="fill"
                                                        type="submit"
                                                   
                                                    >
                                                        Save
                                                    </Button> */}
                        <Button
                          className="cursor-pointer sticky font-small mb-2 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                          shape="round"
                          color="white"
                          size="base"
                          variant="fill"
                          onClick={() => {
                            setvisible(false);
                            navigate(`/taxinvoice/list`);
                          }}
                        >
                          ╳
                        </Button>
                      </div>
                    </div>
                    <div className="flex flex-row items-start justify-start md:ml-[0] m-1 w-full md:w-full  ">
                      <ToastContainer />
                      <div className="flex flex-col items-start justify-start w-[60%]">
                        <div className="md:gap-5 gap-x-[75px] gap-y-4 grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-[100%] ">
                          <div
                            className="ag-theme-quartz relative"
                            style={{
                              height: "350px",
                              //   width: "full",
                              fontSize: "12px",
                            }}
                          >
                            <AgGridReact
                              rowData={taxInvoiceList.map(
                                (taxInvoiceList, index) => ({
                                  ...taxInvoiceList,
                                  sr: index + 1,
                                })
                              )}
                              onRowSelected="single"
                              onRowClicked={onRowClicked}
                              onCellKeyDown={onRowClicked} // For detecting the Tab key press
                              columnDefs={defaultColDefs}
                              defaultColDef={ColDefaultVale}
                              suppressMenuHide={true}
                              suppressExcelExport={true}
                              // gridOptions={gridOptions}
                              overlayLoadingTemplate={
                                loading ? "Loading..." : null
                              }
                              overlayNoRowsTemplate={
                                loading
                                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                                  : "No Record Found"
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* Details Panel */}
                      <div className="w-1/2">
                        {selectedRow ? (
                          <RowDetails row={selectedRow} />
                        ) : (
                          <div className="flex items-center justify-center h-full p-4 bg-gray-100 border-l border-gray-200">
                            <p className="text-gray-500">
                              Select a row to see details
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default TaxInvoiceAddNew;

const RowDetails = ({ row }) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    console.log(row);

    const fetchDetails = async () => {
      try {
        const response = await axios.post(
          `/api/purple-fusion/salesorderitem/get`,
          { sales_order_id: row.id },
          headers
        ); // Replace with your API endpoint
        setDetails(response.data);
        console.log(response.data);
      } catch (err) {
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [row.id]); // Dependency array to refetch when row.id changes

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="p-2 w-full h-full bg-gray-50 border-l border-gray-200">
      <h3 className="font-semibold text-sm mb-2">Sales order Items</h3>
      <div className=" m-auto text-xs grid grid-cols-2 gap-3">
        <p>
          <strong>Customer Name:</strong> {row.customername}
        </p>
        <p>
          <strong>PO Number:</strong> {row.purchesOrderNumber}
        </p>
        <p>
          <strong>Sales Order Code:</strong> {row.code}
        </p>
        {/* <p>
          <strong>Total Taxable Amount:</strong>{" "}
          {Number(
            details.reduce(
              (acc, item) => Number(acc) + Number(item.total_amount),
              0
            )
          ).toFixed(2)}
        </p> */}
      </div>
      {/* Display details in a table format */}
      {details.length > 0 && (
        <div className="overflow-hidden rounded-md">
          <table className="min-w-full mt-2 text-xs border-collapse table-fixed">
            <thead>
              <tr>
                <th className="border text-xs px-4 py-2">Item Name</th>
                <th className="border text-xs px-4 py-2">Code</th>
                <th className="border text-xs px-4 py-2">Quantity</th>
                <th className="border text-xs px-4 py-2">Cost Price</th>
              </tr>
            </thead>
          </table>
          {/* Set a fixed height on tbody and make it scrollable */}
          <div className="max-h-56 overflow-y-auto overflow-x-hidden">
            <table className="min-w-full text-xs border-collapse table-fixed">
              <tbody>
                {details.map((item) => (
                  <tr key={item.id}>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.itemname}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.code_op}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.quantity}
                    </td>
                    <td className="border text-xs px-4 py-2 break-words whitespace-normal">
                      {item.cost_price}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
